import { BaseModel } from './BaseModel';
import Auth from './Auth';

export class SkillProficiency extends BaseModel {
  static get entity() {
    return 'skill-proficiency';
  }

  static get fk() {
    return 'skill_proficiency_id';
  }

  static get LEVEL_SCALE() {
    return {
      NONE: 0,
      BEGINNER: 1,
      INTERMEDIATE: 2,
      ADVANCED: 3
    };
  }

  static get MAX_LEVEL_SCALE() {
    return Math.max(...Object.values(SkillProficiency.LEVEL_SCALE));
  }

  static primaryKey = 'profId';

  static fields() {
    return {
      profId: this.attr(null),
      description: this.attr(null),
      remark: this.attr(null),
      timestamp: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      delete_at: this.attr(null)
    };
  }

  static get globalApiConfig() {
    const headers = {};
    const authToken = Auth.getAppToken();
    if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
    }
    return {
      baseURL: process.env.VUE_APP_SKILL_API_BASE_URL,
      headers
    };
  }

  static apiConfig = {
    actions: {
      async fetch() {
        return this.get(`/skillProficiency/getAvailableSkillProficiencyList`);
      }
    }
  };
}

export default SkillProficiency;
